import { useEffect } from 'react'
import {
  usePageTitleContext,
  type PageTitle,
} from '@/shared/ui/providers/page-title-context'

export function usePageTitle(pageTitle: PageTitle | null): void {
  const { setPageTitle } = usePageTitleContext()
  const title = pageTitle?.title ?? null
  const subtitle = pageTitle?.subtitle ?? null
  const icon = pageTitle?.icon ?? null
  useEffect(() => {
    if (title === null) return
    const next: PageTitle = { title }
    if (subtitle !== null) next.subtitle = subtitle
    if (icon !== null) next.icon = icon
    setPageTitle(next)
    return () => setPageTitle((current) => (current === next ? null : current))
  }, [title, subtitle, icon, setPageTitle])
}
